"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _utils = require("../helpers/utils");

var _bind = _interopRequireDefault(require("../mixins/bind"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Component: Quantity selector
 * ------------------------------------------------------------------------------
 * A form control component to increment/decrement a counter.
 *
 * @namespace quantitySelector
 */

/**
 * DOM selectors.
 */


var selectors = {
  decrement: '[js-quantity-selector="decrement"]',
  increment: '[js-quantity-selector="increment"]',
  input: '[js-quantity-selector="input"]'
};
/**
 * Create a new quantitySelector object.
 * @param {string} selector - Node id selector.
 * @param {Function} callback - Callback function executed after a quantity update.
 * @param {object} config - Configuration.
 */

var _default = function _default(selector, config) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  /**
   * Instance default settings.
   */

  var defaults = {
    minDecreaseValue: 1
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  /**
   * Instance settings.
   */

  var namespace = selector;
  var container = document.getElementById(selector);
  /**
   * Node selectors.
   */

  var nodeSelectors = {
    decrement: container.querySelector(selectors.decrement),
    increment: container.querySelector(selectors.increment),
    input: container.querySelector(selectors.input)
  };
  /**
   * Initialise component bind.
   */

  var binder = (0, _bind["default"])(container);
  /**
   * Initialise component.
   */

  function init() {
    if (binder.isSet()) {
      return;
    }

    setListeners();
    setTriggerEvents();
    binder.set();
  }
  /**
   * Set listeners for each instance.
   */


  function setListeners() {
    Frame.EventBus.listen("".concat(namespace, ":update"), function (value) {
      update(value);
      executeCallback();
    });
  }
  /**
   * Set click listeners.
   */


  function setTriggerEvents() {
    (0, _utils.on)('click', nodeSelectors.increment, function (event) {
      return handleQuantityUpdate('increment', event);
    });
    (0, _utils.on)('click', nodeSelectors.decrement, function (event) {
      return handleQuantityUpdate('decrement', event);
    });
  }
  /**
   * Handle quantity updates.
   * @param {string} type - Quantity update type (increment/decrement).
   * @param {Event} event - Click event.
   */


  function handleQuantityUpdate(type, event) {
    event.preventDefault();
    var inputValue = nodeSelectors.input.value;
    var currentValue = type === 'increment' ? parseInt(inputValue, 10) + 1 : parseInt(inputValue, 10) - 1;
    var minVal = settings.minDecreaseValue;

    if (validate(currentValue, minVal)) {
      Frame.EventBus.emit("".concat(namespace, ":update"), currentValue);
    }
  }
  /**
   * Validate input.
   * @param {Integer} value - Value to validate.
   */


  function validate(value, minVal) {
    return !isNaN(value) && value >= minVal;
  }
  /**
   * Update DOM value and execute callback.
   * @param {Integer} value - Value to replace on DOM.
   */


  function update(value) {
    nodeSelectors.input.setAttribute('value', value);
  }
  /**
   * Execute callback function defined in constructor.
   */


  function executeCallback() {
    return typeof callback === 'function' ? callback() : false;
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init,
    update: update
  });
};

exports["default"] = _default;